// Vuex
import {mapActions} from 'vuex';

// Utils.
import moment from 'moment';

// Components
import ComplaintsTab from '@/views/Appointment/Form/ComplaintsTab';
import PatientTab from '@/views/Patient/Detail/InformationTab/PersonalInfoTab';
import MedicalHistoryTab from '@/views/Appointment/Form/MedicalHistoryTab';
import SocialHistoryTab from '@/views/Appointment/Form//SocialHistoryTab';
import VitalsTab from '@/views/Appointment/Form//Vitals';
import DiagnosisTab from '@/views/Appointment/Form//DiagnosisTab';
import NotesTab from '@/views/Appointment/Form//NotesTab';
import PrescriptionTab from '@/views/Prescription/PrescriptionList';
import LabExamTab from '@/views/Appointment/Form//LabExam';

// Constants
import * as APPOINTMENT from '@/store/constants/appointment';
import * as VITAL from '@/store/constants/vital';


export default {
  components: {
    PatientTab,
    LabExamTab,
    VitalsTab,
    ComplaintsTab,
    MedicalHistoryTab,
    SocialHistoryTab,
    DiagnosisTab,
    NotesTab,
    PrescriptionTab
  },
  data() {
    return {
      tabs: [
        {key: 'patient-tab', text: 'Patient Info'},
        {key: 'complaints-tab', text: 'Reason for Consultation'},
        // {key: 'medical-history-tab', text: 'Medical History'},
        // {key: 'social-history-tab', text: 'Social History'},
        {key: 'vitals-tab', text: 'Vitals'},
        {key: 'diagnosis-tab', text: 'Diagnosis'},
        {key: 'notes-tab', text: 'Notes'},
        {key: 'prescription-tab', text: 'Prescription'},
        // {key: 'lab-exam-tab', text: 'Lab Exam'}
      ],
      tabIndex: 0,
      can_preview: false,
      patient: {},
      mode: 'add',
      original_appointment: {},
      appointment: {
        vital: {}
      },
      appointment_id: null,
      notification: {}
    }
  },

  methods: {
    ...mapActions({
      addAppointment: APPOINTMENT.ACTION_ADD,
      getAppointment: APPOINTMENT.ACTION_GET_APPOINTMENT,
      updateAppointment: APPOINTMENT.ACTION_UPDATE,
      addVital: VITAL.ACTION_ADD,
      updateVital: VITAL.ACTION_UPDATE,
    }),

    /**
     * Adding of updating vital data.
     *
     * @param appointment
     * @returns {*}
     */
    addOrUpdateVital(appointment) {
      return (!this.original_appointment.vital)
        ? this.addVital(appointment.vital)
        : this.updateVital(appointment.vital);
    },

    /**
     * Handle update appointment.
     */
    handleUpdateAppointment() {
      this.addOrUpdateVital(this.appointment);
      this.updateAppointment(this.appointment).then(res => {
        this.notification = {
          show: true,
          message: 'Appointment successfully updated.',
          variant: 'alert-success'
        }
      });
    },

    /**
     * Handle addition of appointment.
     *
     * @returns {Promise<void>}
     */
    async handleAddAppointment() {
      const res = await this.addOrUpdateVital(this.appointment);
      this.appointment.vital_id = res.data.id;

      this.addAppointment(this.appointment).then(res => {
        this.notification = {
          show: true,
          message: 'Appointment successfully added.',
          variant: 'alert-success'
        };

        this.mode = 'edit';
      });
    },

    can_generate_certificate() {
      return (this.appointment.diagnosis && this.appointment.notes);
    },

    /**
     * Add or update appointment.
     */
    save() {
      console.log('Saving appointment');
      this.notification = {};

      console.log(this.mode, 'mode');
      console.log(this.appointment, 'appointment');

      (this.mode === 'add' && this.appointment)
        ? this.handleAddAppointment()
        : this.handleUpdateAppointment();
    },


    /**
     * Refresh data list.
     */
    refreshData() {
      console.log('refreshing appointment data');
      if (this.appointment_id) {
        this.mode = 'edit';
        this.getAppointment(this.appointment_id).then(res => {
          this.original_appointment = res.data;
          this.appointment = {...this.appointment, ...res.data};
          this.patient = this.appointment.patient;
          if (this.appointment.vital === null) this.appointment.vital = {}
        });
      } else {
        this.appointment = {
          ...this.appointment, ...{
            appointment_date: moment().format('YYYY-MM-DD')
          }
        };
      }
    },
  },

  created() {
    this.appointment_id = this.$route.params['id'];
    this.refreshData();
  }
}



// WEBPACK FOOTER //
// ./src/views/Appointment/js/appointment-form-detail.js